import { Component, OnInit } from '@angular/core';
import {EntidadEmpresarialEntity, ServicioEntidadService} from '../../../services/servicio-entidad.service';
import {ActivatedRoute} from '@angular/router';
import {ServicioAdmisionesService} from '../../../services/servicio-admisiones.service';
import {LoginEntity, ServicioLoginService} from '../../../services/servicio-login.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ImagesService} from '../../../services/utils/images.service';

@Component({
  selector: 'app-movimiento-paciente-by-rango-fecha',
  templateUrl: './movimiento-paciente-by-rango-fecha.component.html',
  styleUrls: ['./movimiento-paciente-by-rango-fecha.component.css']
})
export class MovimientoPacienteByRangoFechaComponent implements OnInit {

  mensajeLoading = 'Cargando...';
  codigoBaseDatos: string;
  mensajeError: string;
  logo: string;

  usuario: LoginEntity = {};
  entidad: EntidadEmpresarialEntity = {};

  fechaImpresion: Date = new Date();
  obj: any = {};
  public dataKeys: any[] = [];

  constructor(
    private servicioAdmisiones: ServicioAdmisionesService,
    private servicioLogin: ServicioLoginService,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.codigoBaseDatos = params.codigoBaseDatos;
      this.uncoSede = params.uncoSede;
      this.uncoLogin = params.uncoLogin;
    });
  }

  private uncoSede: number;
  private uncoLogin: number;

  ngOnInit() {
    this.getLogo();
    this.getInformacionUsuario();
  }

  private async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioImagenes.getLogo(this.codigoBaseDatos);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        this.logo = null;
        this.getEntidadEmpresarial();
        console.error('Error MovimientoPacienteByRangoFechaComponent.getLogo()', err);
      });
    } catch (e) {
      this.logo = null;
      this.getEntidadEmpresarial();
      console.error('Catch MovimientoPacienteByRangoFechaComponent.getLogo()', e);
    }
  }

  private async getEntidadEmpresarial() {

    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.codigoBaseDatos,
        this.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        this.entidad = data[0];
        this.getInformacionUsuario();
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error MovimientoPacienteByRangoFechaComponent.getEntidadEmpresarial()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error grave al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch MovimientoPacienteByRangoFechaComponent.getEntidadEmpresarial()', e);
    }
  }

  private async getInformacionUsuario() {
    try {
      this.mensajeLoading = 'Cargando información usuario ...';
      const response = await this.servicioLogin.getUsuario(this.codigoBaseDatos, this.uncoLogin);
      response.subscribe((data: LoginEntity) => {
        this.usuario = data;
        this.mensajeLoading = '';
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error MovimientoPacienteByRangoFechaComponent.getInformacionUsuario()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch MovimientoPacienteByRangoFechaComponent.getInformacionUsuario()', e);
    }
  }

  async onFiltrosCompletados(filtros: any) {
    const response = await this.servicioAdmisiones.getMovimientoPacienteByRangoFecha(this.codigoBaseDatos, filtros.ln_unco_sede, filtros.ln_fec_ini, filtros.ln_fec_fin);

    response.subscribe((data: any[]) => {
      for (const item of data) {
        if (!this.obj[item.afiliado]) {
          this.obj[item.afiliado] = [];
        }
        this.obj[item.afiliado].push(item);
      }
      this.dataKeys = Object.keys(this.obj);
    }, (error) => {
      console.error('Error MovimientoPacienteByRangoFechaComponent.onFiltrosCompletados()', error);
      this.onErrorGenerado('Ocurrió un error al consultar las relaciones admisiones, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  isAvailableBody() {
    return !this.mensajeLoading && !this.mensajeError;
  }

  onErrorGenerado(error: string) {
    this.mensajeError = error;
  }
}
